<template>
    <!-- <div id="footerbox" class="content">
        技术支持：慕华成志教育科技有限公司  2020-2021 版权所有 &nbsp;&nbsp;&nbsp; a href="https://beian.miit.gov.cn">ICP证：京ICP备16003915号-1</a>
    </div> -->
        <div class="footerPreview">

          <Row id="content">
            <Col  span="16">
              <div class="name">{{ footerData.text1 }}</div>
              <div class="info">
                  <div style="text-align:left;width:100%;margin-top:14px;">技术支持：{{ footerData.text2 }}</div>
              </div>
            </Col>
            <Col  span="8">
              <div class="computyName" :class="{'icpmt':!showicp}">{{ footerData.text3 }}</div>
              <div class="beian" v-if="showicp"><a href="https://beian.miit.gov.cn">ICP证：粤ICP备2023004689号-5</a></div>
            </Col>
          </Row>
        </div>
</template>
<script>
export default {
  name: 'FootBottom',
  props: {
    footerData: {
      type: Object,
      default: null
    }
  },
  mounted () {
    console.log(this.footerData)
    const hostname = location.hostname.split('.')[0]
    this.showicp = hostname !== 'tzxdjy'
  },
  data () {
    return {
      showicp:true
    }
  }
}
</script>
<style lang="">
    .footerPreview{
      height: 124px;
      background: #2E2D2D;
      color: #797878;
      
    }
    .name{
        text-align: left;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 31px;
      }
      .computyName{
        margin-top: 31px;
        text-align: left;
      }
      .icpmt{
        margin-top: 50px;
      }
      .beian{
        margin-top: 14px;
        text-align: left;
      }
      .beian a {
        color: #797878;
      }
      .beian a:hover{
        text-decoration: underline;
      }
</style>



// WEBPACK FOOTER //
// src/components/footBottom/footer.vue